import { useEffect, useState } from 'react';
import { getAdminModules } from 'zite-endpoints-sdk';
import { Skeleton } from '@/components/ui/skeleton';
import { Input } from '@/components/ui/input';
import { Search, BookOpen } from 'lucide-react';

export default function ModulesAdminSection() {
  const [modules, setModules] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    getAdminModules({}).then((d: any) => setModules(d.modules || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const filtered = modules.filter(m =>
    (m.title || '').toLowerCase().includes(search.toLowerCase())
  );

  if (loading) return <div className="space-y-3">{[1,2,3].map(i => <Skeleton key={i} className="h-12" />)}</div>;

  return (
    <div>
      <h2 className="text-lg font-bold text-foreground mb-4">Modules</h2>

      <div className="flex items-center gap-3 mb-4">
        <div className="relative flex-1 max-w-sm">
          <Search className="w-4 h-4 text-muted-foreground absolute left-2.5 top-1/2 -translate-y-1/2" />
          <Input placeholder="Search modules…" value={search} onChange={e => setSearch(e.target.value)} className="pl-9" />
        </div>
      </div>

      {filtered.length === 0 ? (
        <div className="text-center py-12"><BookOpen className="w-10 h-10 text-muted-foreground mx-auto mb-2 opacity-50" /><p className="text-sm text-muted-foreground">No modules found</p></div>
      ) : (
        <div className="space-y-2">
          {filtered.map((m: any) => (
            <div key={m.id} className="flex items-center gap-4 p-4 bg-card border border-border rounded-lg">
              <BookOpen className="w-5 h-5 text-primary shrink-0" />
              <div className="flex-1 min-w-0">
                <p className="font-medium text-foreground truncate">{m.title}</p>
                <p className="text-xs text-muted-foreground">{m.contentType || 'Module'} · {m.department || 'All'}</p>
              </div>
              <span className={`text-xs px-2 py-0.5 rounded ${m.status === 'Published' ? 'bg-primary/10 text-primary' : 'bg-muted text-muted-foreground'}`}>
                {m.status || 'Draft'}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
